module.exports = {
  Base64: require('./storageAuth/ali/base64'),
  AliCrypto: require('./storageAuth/ali/crypto-hmac-sha1'),
};
